@if (result(); as item) {
  <soft-ktostamm-kunde-subnummer-field-ok-data-view
    [item]="item"
  ></soft-ktostamm-kunde-subnummer-field-ok-data-view>
}
